import React from 'react';
import moment, { Moment } from 'moment-timezone';
import { Form, Label, SemanticWIDTHS } from 'semantic-ui-react';

import DatePicker from '@src/components/common/DatePicker';

import CustomLabel from './CustomLabel';

type DatePickerProps = {
  date?: Date | Moment;
  format?: string;
  inputEnabled?: boolean;
  handleChange: (d: Moment) => void;
  required?: boolean;
  errors: any;
  label: string;
  sublabel?: string;
  fieldName: string;
  disabledDates?: (date: Date) => boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  showTime?: boolean;
  width?: SemanticWIDTHS;
};

export const FormDatePicker = ({
  date,
  format = 'YYYY-MM-DD HH:mm:ss (UTC)',
  inputEnabled = true,
  handleChange,
  required = true,
  errors = {},
  label,
  sublabel,
  fieldName,
  disabledDates = (date: Date) => date > new Date(),
  disabled = false,
  style = {},
  showTime = false,
  width,
}: DatePickerProps) => {
  return (
    <Form.Field required={required} style={style} width={width}>
      {errors[fieldName] && (
        <Label color="red" pointing="below">
          {errors[fieldName]}
        </Label>
      )}
      <CustomLabel label={label} sublabel={sublabel} />
      <DatePicker
        value={date ? moment.utc(date) : ''}
        inputEnabled={inputEnabled}
        format={format}
        handleChange={handleChange}
        disabledDates={disabledDates}
        timePickerDisabled={disabled}
        showTime={showTime}
        error={false}
        width="100%"
      />
    </Form.Field>
  );
};
